export default __webpack_public_path__ + "static/media/sell3.d2ef29a1.svg";